import { render } from "./GlobalPostLessonPrompt.vue?vue&type=template&id=17893c78"
import script from "./GlobalPostLessonPrompt.vue?vue&type=script&lang=js"
export * from "./GlobalPostLessonPrompt.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__